var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "monitoring" },
    [
      _c("div", { staticClass: "container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "monitoring__content" },
          [
            _c("div", { staticClass: "monitoring__content-search-block" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchQuery,
                    expression: "searchQuery",
                  },
                ],
                staticClass: "monitoring__content-search",
                attrs: { value: "", placeholder: "Поиск по ИНН ФЛ или ФИО" },
                domProps: { value: _vm.searchQuery },
                on: {
                  keypress: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return function () {
                      _vm.getCompanies()
                    }.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchQuery = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _vm.searchQuery
                ? _c("i", {
                    staticClass: "lnr lnr-cross",
                    on: {
                      click: function () {
                        _vm.searchQuery = ""
                        _vm.getCompanies()
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.searchQuery
                ? _c("i", {
                    staticClass: "lnr lnr-magnifier",
                    on: {
                      click: function () {
                        _vm.getCompanies()
                      },
                    },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.loading
              ? _c("shestirenkaLoader")
              : _vm.monitoringCompanies.length
              ? [
                  _c("div", { staticClass: "monitoring__content-sort" }, [
                    _c("span", [_vm._v("Сортировать: ")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "monitoring__content-sort-item",
                        on: {
                          click: function ($event) {
                            return _vm.sortBy("changed_at")
                          },
                        },
                      },
                      [
                        _vm.order_by == "changed_at"
                          ? [
                              _vm.order_type == "desc"
                                ? _c("i", { staticClass: "fas fa-chevron-up" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.order_type == "asc"
                                ? _c("i", {
                                    staticClass: "fas fa-chevron-down",
                                  })
                                : _vm._e(),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [_vm._v("по дате изменения")]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "monitoring__content-sort-item",
                        on: {
                          click: function ($event) {
                            return _vm.sortBy("rstperson_fio")
                          },
                        },
                      },
                      [
                        _vm.order_by == "rstperson_fio"
                          ? [
                              _vm.order_type == "desc"
                                ? _c("i", { staticClass: "fas fa-chevron-up" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.order_type == "asc"
                                ? _c("i", {
                                    staticClass: "fas fa-chevron-down",
                                  })
                                : _vm._e(),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [_vm._v("по ФИО")]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "monitoring__content-sort-item",
                        on: {
                          click: function ($event) {
                            return _vm.sortBy("count_unseen")
                          },
                        },
                      },
                      [
                        _vm.order_by == "count_unseen"
                          ? [
                              _vm.order_type == "desc"
                                ? _c("i", { staticClass: "fas fa-chevron-up" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.order_type == "asc"
                                ? _c("i", {
                                    staticClass: "fas fa-chevron-down",
                                  })
                                : _vm._e(),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [_vm._v("по кол-ву новых изменений")]),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.pagination
                    ? _c("pagination", {
                        attrs: {
                          pagination: _vm.pagination,
                          onTurnPageCallBack: _vm.getCompanies,
                          showRowsPerPageSelection: true,
                          rows_on_page: _vm.monitoringCompanies.length,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("table", { staticClass: "monitoring__table" }, [
                    _c("thead", [
                      _c("tr", { staticClass: "monitoring__table-header" }, [
                        _c("th", [_vm._v("ИНН ФЛ")]),
                        _vm._v(" "),
                        _c("th", [
                          _c("span", [_vm._v("ФИО, должность, родство")]),
                        ]),
                        _vm._v(" "),
                        _c("th", [_c("div", [_vm._v("Последнее изменение")])]),
                        _vm._v(" "),
                        _c(
                          "th",
                          { staticClass: "monitoring__table-header-changes" },
                          [
                            _c("div", [_vm._v("Кол-во изменений")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "font-size": "12px" } },
                              [
                                _vm._v(
                                  "(" +
                                    _vm._s(_vm.countUnseen) +
                                    " из " +
                                    _vm._s(_vm.countTotal) +
                                    ")"
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.monitoringCompanies, function (e, i) {
                        return _c(
                          "tr",
                          { key: i, staticClass: "monitoring__table-item" },
                          [
                            _c("td", [_vm._v(_vm._s(e.rstperson_inn))]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                e.rstperson_inn
                                  ? _c("person-afil", {
                                      attrs: {
                                        inn: e.rstperson_inn,
                                        fio: e.rstperson_fio,
                                        showAfilNetworkTooltip: true,
                                      },
                                    })
                                  : _c("div", [
                                      _vm._v(_vm._s(e.rstperson_fio)),
                                    ]),
                                _vm._v(" "),
                                e.rstperson_type == "relative"
                                  ? _c(
                                      "div",
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              e.rstperson_role
                                                ? e.rstperson_role +
                                                    " сотрудника"
                                                : "сотрудник"
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        e.relation_inn
                                          ? _c("person-afil", {
                                              attrs: {
                                                inn: e.relation_inn,
                                                fio: e.relation_name,
                                                showAfilNetworkTooltip: true,
                                              },
                                            })
                                          : _c("span", [
                                              _vm._v(_vm._s(e.relation_name)),
                                            ]),
                                      ],
                                      1
                                    )
                                  : e.rstperson_type == "staff"
                                  ? _c("div", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            e.rstperson_role
                                              ? e.rstperson_role
                                              : "сотрудник"
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      e.relation_ogrn
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "blue-red-hover-text",
                                              attrs: {
                                                href:
                                                  "/company/" + e.relation_ogrn,
                                                target: "_blank",
                                              },
                                            },
                                            [_vm._v(_vm._s(e.relation_name))]
                                          )
                                        : _c("span", [
                                            _vm._v(_vm._s(e.relation_name)),
                                          ]),
                                    ])
                                  : _c("div", [
                                      _c("span", [_vm._v("сотрудник")]),
                                    ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    new Date(e.changed_at).toLocaleDateString()
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.changeTypeTitle(e.change_type_title)
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "monitoring__table-item-changes" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "monitoring__table-item-changes-new",
                                  },
                                  [_vm._v("Новых " + _vm._s(e.count_unseen))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "monitoring__table-item-changes-all",
                                  },
                                  [_vm._v("Всего " + _vm._s(e.count_total))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "monitoring__table-item-changes-show",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showCompanyChanges(
                                          0,
                                          50,
                                          e.rstperson_inn,
                                          e.rstperson_fio
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Показать")]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.pagination
                    ? _c("pagination", {
                        attrs: {
                          pagination: _vm.pagination,
                          onTurnPageCallBack: _vm.getCompanies,
                          showRowsPerPageSelection: true,
                          rows_on_page: _vm.monitoringCompanies.length,
                        },
                      })
                    : _vm._e(),
                ]
              : [
                  _c("h3", { staticStyle: { margin: "10px 0" } }, [
                    _vm._v("Сотрудник не найден"),
                  ]),
                ],
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.showCompanyChangesModal
        ? _c(
            "modal",
            {
              attrs: {
                close: _vm.closeModalHandler,
                printButton: true,
                downloadButton: false,
              },
            },
            [
              _c(
                "span",
                { attrs: { slot: "modalHeader" }, slot: "modalHeader" },
                [
                  _vm._v("Список изменений "),
                  _c(
                    "a",
                    {
                      staticStyle: { border: "0" },
                      attrs: {
                        href: "/company/" + _vm.comapnyChangesOGRN,
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.comapnyChangesName))]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { padding: "10px" },
                  attrs: { slot: "modalBody" },
                  slot: "modalBody",
                },
                [
                  _vm.companyChangesPagination
                    ? _c("pagination", {
                        attrs: {
                          pagination: _vm.companyChangesPagination,
                          onTurnPageCallBack: _vm.getCompanyChanges,
                          showRowsPerPageSelection: true,
                          rows_on_page: _vm.companyChangesData.length,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("table", { staticClass: "simple-table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Изменение")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Дата обновления информации")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Старые данные")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Новые данные")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.companyChangesData, function (e, i) {
                        return _c("tr", { key: i }, [
                          _c("td", { staticStyle: { "font-weight": "400" } }, [
                            e.change_type_title
                              ? _c("span", [
                                  _vm._v(_vm._s(e.change_type_title)),
                                ])
                              : e.change_type == "added"
                              ? _c("span", [
                                  _vm._v(
                                    "\n                                Регистрация ИП\n                            "
                                  ),
                                ])
                              : e.change_type == "updated"
                              ? _c(
                                  "span",
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "Изменение информации о собственности"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "card-link",
                                      { attrs: { ogrn: e.ogrn } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            e.name_short
                                              ? e.name_short
                                              : e.name_full
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : e.change_type == "deleted"
                              ? _c("span", [
                                  _vm._v(
                                    "\n                                Ликвидация ИП\n                            "
                                  ),
                                ])
                              : _c("span", [_vm._v("—")]),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                new Date(e.changed_at).toLocaleDateString()
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              e.data_old &&
                              e.data_old.length &&
                              e.data_old[0] != null
                                ? _vm._l(e.data_old, function (e, i) {
                                    return _c(
                                      "div",
                                      { key: i },
                                      [
                                        e.title
                                          ? _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "font-weight": "400",
                                                  margin: "15px 0",
                                                },
                                              },
                                              [_vm._v(_vm._s(e.title))]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        e.value
                                          ? _c("p", [_vm._v(_vm._s(e.value))])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        e.ogrn && e.name_full
                                          ? _c(
                                              "card-link",
                                              { attrs: { ogrn: e.ogrn } },
                                              [_vm._v(_vm._s(e.name_full))]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        e.attributes && e.attributes.length
                                          ? _vm._l(
                                              e.attributes,
                                              function (e, i) {
                                                return _c(
                                                  "p",
                                                  {
                                                    key: i,
                                                    staticStyle: {
                                                      margin: "0",
                                                    },
                                                  },
                                                  [
                                                    e.title
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(e.title) +
                                                              ":"
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    e.value
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(e.value)
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                )
                                              }
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  })
                                : [_vm._v("—")],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              e.data_new &&
                              e.data_new.length &&
                              e.data_new[0] != null
                                ? [
                                    e.change_type == "/КадНовый" &&
                                    e.data_new[0].id
                                      ? [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "http://kad.arbitr.ru/Card/" +
                                                  e.data_new[0].id,
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(e.data_new[0].number)
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._l(e.data_new, function (e, i) {
                                          return _c(
                                            "div",
                                            { key: i },
                                            [
                                              e.title
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "400",
                                                        margin: "15px 0",
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(e.title))]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              e.value
                                                ? _c("p", [
                                                    _vm._v(_vm._s(e.value)),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              e.ogrn && e.name_full
                                                ? _c(
                                                    "card-link",
                                                    { attrs: { ogrn: e.ogrn } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(e.name_full)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              e.attributes &&
                                              e.attributes.length
                                                ? _vm._l(
                                                    e.attributes,
                                                    function (e, i) {
                                                      return _c(
                                                        "p",
                                                        {
                                                          key: i,
                                                          staticStyle: {
                                                            margin: "0",
                                                          },
                                                        },
                                                        [
                                                          e.title
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    e.title
                                                                  ) + ":"
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          e.value
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    e.value
                                                                  )
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    }
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        }),
                                  ]
                                : [_vm._v("—")],
                            ],
                            2
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.companyChangesPagination
                    ? _c("pagination", {
                        attrs: {
                          pagination: _vm.companyChangesPagination,
                          onTurnPageCallBack: _vm.getCompanyChanges,
                          showRowsPerPageSelection: true,
                          rows_on_page: _vm.companyChangesData.length,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "monitoring__header" }, [
      _c("h2", [_vm._v("Мониторинг сотрудников и членов их семей")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }